const _import = require('../import-' + process.env.NODE_ENV)

const headlineRouter = [
  {
    path: '/headline/Index',
    name: 'headlineList',
    component: _import('headline/Index'),
    meta: {
      title: '公司新闻',
      keepAlive: true
    }},
  {
    path: '/headline/Detail',
    name: 'headlineDetail',
    component: _import('headline/Detail'),
    meta: {
      title: '新闻详情'
    }
  }
]
export default headlineRouter



// WEBPACK FOOTER //
// ./src/router/home/headline.js